
/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import Vue from 'vue';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';


/** Load all vue files in this folder, recursively */
const requireComponent = require.context(
    './', true, /\.vue$/
);

requireComponent
    .keys()
    .filter((file) => !file.toLowerCase().includes('/global/'))
    .forEach((fileName) => {
      // Load component
      const componentConfig = requireComponent(fileName);

      // Get component name
      const componentName = upperFirst(
          camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
      );

      // Register component
      Vue.component(`Leyton${componentName}`,
          componentConfig.default || componentConfig);
    });
